import { addTokenHeader, BusinessAxiosConfig, RequestConfig } from '@src/config';
import { BUSINESS_API_VERSION } from '@src/constants';
import ClientApi from '@src/types/client';
import { getState } from '@src/utils';
import { setFormIfValueIsDefined } from '@src/utils/setFormIfValueIsDefined';
import { AxiosResponse } from 'axios';

export const getWhiteLabelConfigurationService = (
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.GetWhiteLabelConfigurations.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const configWithToken = addTokenHeader(token || '');
  return BusinessAxiosConfig.get<
    ClientApi.WhiteLabel.GetWhiteLabelConfigurations.Response,
    AxiosResponse<ClientApi.WhiteLabel.GetWhiteLabelConfigurations.Response>
  >(`/api/v${BUSINESS_API_VERSION}/WhiteLabel/GetWhiteLabelConfigurations`, {
    ...config,
    ...configWithToken
  }).then((res) => res.data);
};

export const saveMediaFilesService = (
  payload: ClientApi.WhiteLabel.SaveMediaFiles.Request,
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.SaveMediaFiles.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const formData = new FormData();

  Object.entries(payload).forEach(([key, value]) => {
    setFormIfValueIsDefined(formData, key, value);
  });

  const configWithToken = addTokenHeader(token || '', 'formData');
  return BusinessAxiosConfig.post<
    ClientApi.WhiteLabel.SaveMediaFiles.Response,
    AxiosResponse<ClientApi.WhiteLabel.SaveMediaFiles.Response>
  >(`/api/v${BUSINESS_API_VERSION}/WhiteLabel/OptionalMediaFilesSave`, formData, {
    ...config,
    ...configWithToken
  }).then((res) => res.data);
};

export const saveStylingConfigurationService = (
  payload: ClientApi.WhiteLabel.SaveStylingConfiguration.Request,
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.SaveStylingConfiguration.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const configWithToken = addTokenHeader(token || '');
  return BusinessAxiosConfig.post<
    ClientApi.WhiteLabel.SaveStylingConfiguration.Response,
    AxiosResponse<ClientApi.WhiteLabel.SaveStylingConfiguration.Response>
  >(`/api/v${BUSINESS_API_VERSION}/WhiteLabel/SaveStylingConfiguration`, payload, {
    ...config,
    ...configWithToken
  }).then((res) => res.data);
};

export const saveSocialLinksService = (
  payload: ClientApi.WhiteLabel.SaveSocialLinks.Request,
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.SaveSocialLinks.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const configWithToken = addTokenHeader(token || '');
  return BusinessAxiosConfig.post<
    ClientApi.WhiteLabel.SaveSocialLinks.Response,
    AxiosResponse<ClientApi.WhiteLabel.SaveSocialLinks.Response>
  >(`/api/v${BUSINESS_API_VERSION}/WhiteLabel/SaveSocialLinks`, payload, {
    ...config,
    ...configWithToken
  }).then((res) => res.data);
};

export const saveSmtpSettingsService = (
  payload: ClientApi.WhiteLabel.SaveSmtpSettings.Request,
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.SaveSmtpSettings.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const configWithToken = addTokenHeader(token || '');
  return BusinessAxiosConfig.post<
    ClientApi.WhiteLabel.SaveSmtpSettings.Response,
    AxiosResponse<ClientApi.WhiteLabel.SaveSmtpSettings.Response>
  >(`/api/v${BUSINESS_API_VERSION}/WhiteLabel/SaveSmtpSettings`, payload, {
    ...config,
    ...configWithToken
  }).then((res) => res.data);
};

export const saveDomainSettingsService = (
  payload: ClientApi.WhiteLabel.SaveDomainSettings.Request,
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.SaveDomainSettings.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const configWithToken = addTokenHeader(token || '');
  return BusinessAxiosConfig.post<
    ClientApi.WhiteLabel.SaveDomainSettings.Response,
    AxiosResponse<ClientApi.WhiteLabel.SaveDomainSettings.Response>
  >(`/api/v${BUSINESS_API_VERSION}/WhiteLabel/SaveDomainSettings`, payload, {
    ...config,
    ...configWithToken
  }).then((res) => res.data);
};

export const domainNameCheckService = (
  payload: ClientApi.WhiteLabel.DomainNameCheck.Request,
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.DomainNameCheck.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const configWithToken = addTokenHeader(token || '');
  return BusinessAxiosConfig.get<
    ClientApi.WhiteLabel.DomainNameCheck.Response,
    AxiosResponse<ClientApi.WhiteLabel.DomainNameCheck.Response>
  >(`/api/v${BUSINESS_API_VERSION}/WhiteLabel/DomainNameCheck`, {
    ...config,
    ...configWithToken,
    params: {
      ...payload
    }
  }).then((res) => res.data);
};

export const publishWhiteLabelService = (
  config?: RequestConfig
): Promise<ClientApi.WhiteLabel.PublishWhiteLabel.Response> => {
  const state = getState();
  const token = state?.tokens?.token.accessToken;

  const configWithToken = addTokenHeader(token || '');
  return BusinessAxiosConfig.post<
    ClientApi.WhiteLabel.PublishWhiteLabel.Response,
    AxiosResponse<ClientApi.WhiteLabel.PublishWhiteLabel.Response>
  >(
    `/api/v${BUSINESS_API_VERSION}/WhiteLabel/Publish`,
    {},
    {
      ...config,
      ...configWithToken
    }
  ).then((res) => res.data);
};
